import styles from './FAQ.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Link } from 'react-router-dom'
import { Button } from 'components/Button/Button'


export function FAQ() {

    function navigateToFAQ() {
        window.open('http://localhost:3000/faq', '_blank')
    }

    return (
        <div className={styles['wrapper']}>
            <div>
                <div className={styles['icon']}>
                    <Icon name='faq' />
                </div>
                <div className={styles['description']}>
                    Support any creator
                    <br />
                    through Drizzle
                </div>
                <ul className={styles['list']}>
                    <li>Deposit crypto dollars into an interest protocol (
                        <Link to='/' className={styles['link']}>see how</Link>
                        )</li>
                    <li>Send a link to someone</li>
                    <li>They can claim interest from your deposit</li>
                    <li>You can withdraw the deposit anytime</li>
                </ul>
            </div>
            <div>
                <Button
                    size='s'
                    type='light'
                    iconName='external'
                    iconRight={true}
                    stretch={false}
                    onClick={navigateToFAQ}>
                    See full FAQ
                </Button>
            </div>
        </div>
    )
}

